import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IKeybindingEditingService = ( createDecorator('keybindingEditingService'));
export { IKeybindingEditingService };
